import { Col, Row } from 'antd';
import { useGetViewType } from 'Pages/Home/Hooks/useGetViewType';
import { useMakeInfiniteScroll } from 'Pages/Home/Hooks/useMakeInfiniteScroll';
import React, { useEffect, useLayoutEffect, useMemo, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import Button from '../../Atoms/Button';
import Card from '../../Atoms/Card';
import Grid from '../../Atoms/Grid';
import InfiniteScroll from '../../Molecules/InfiniteScroll';
import Section from '../../Molecules/Section';
import Styles from './WhatsGoingOnSection.module.scss';
import { fetchResetInstagramFeedData } from 'Pages/Home/Hooks/useFetchResetInstagramFeedData';

export type TWhatsGoingOnItems = {
  image: string;
  redirectUrl?: string;
  caption?: string;
};

type TWhatsGoingOnSectionProps = {
  className?: string;
  items: TWhatsGoingOnItems[];
};

const WhatsGoingOnSection: React.FC<TWhatsGoingOnSectionProps> = ({
  className,
  items,
}) => {
  const [renderData, setRenderData] = useState<TWhatsGoingOnItems[]>([]);
  const [hasErrorImage, setHasErrorImage] = useState<boolean>(false);
  const [isAlreadyReset, setIsAlreadyReset] = useState<boolean>(false);
  const [scrollPosition, setScrollPosition] = useState<number>(0);
  const { isMobileView } = useGetViewType();
  const {
    data: infiniteScrollData,
    isLoading,
    hasMoreData,
    loadMore,
  } = useMakeInfiniteScroll({
    dataSource: items,
    perPage: 6,
  });

  const handleScroll = () => {
    const maxScrollY = document.body.scrollHeight - document.body.clientHeight;
    const position = Math.ceil(window.scrollY);
    if (position > maxScrollY * 0.75) {
      setScrollPosition(position);
    }
  };

  const wrapperClassName = useMemo(() => {
    return className ? className : Styles['wrapper'];
  }, [className]);

  const renderItem = useMemo(() => {
    return renderData.map((item, index) => {
      return (
        <Col key={`whats-going-on-card-${index}`} span={4} xs={8} md={4}>
          <Card.Social
            onClick={() => {
              if (item.redirectUrl) {
                window.open(item.redirectUrl, '_blank');
              }
            }}
            alt={`ig-feeds-${index + 1}`}
            backgroundImage={item.image}
            height={
              isMobileView ? '100%' : 'calc(100vw / 6 - 48px)'
            }
            width={'100%'}
            onError={() => {
              if (!hasErrorImage) {
                setHasErrorImage(true);
              }
            }}
          />
        </Col>
      );
    });
  }, [renderData, isMobileView]);

  useLayoutEffect(() => {
    setRenderData(isMobileView ? items : infiniteScrollData);
  }, [items, isMobileView]);

  useEffect(() => {
    if (hasErrorImage && !isAlreadyReset) {
      const exec = async () => {
        await fetchResetInstagramFeedData();
        setIsAlreadyReset(true);
      };

      exec();
    }
  }, [hasErrorImage]);

  useEffect(() => {
    if (isMobileView) {
      return;
    }

    setRenderData(infiniteScrollData);
  }, [infiniteScrollData]);

  useEffect(() => {
    const maxScrollY = document.body.scrollHeight - document.body.clientHeight;
    if (scrollPosition >= maxScrollY - 50) {
      if (!isLoading) {
        loadMore();
      }
    }
  }, [scrollPosition]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={wrapperClassName}>
      <Section
        title="WHAT'S GOING ON"
        actionText="Visit our Instagram"
        onAction={() => {
          window.open('https://www.instagram.com/kick.avenue/', '_blank');
        }}
        canHorizontalScroll={false}
      >
        <InfiniteScroll
          renderContent={<Grid gutter={[24, 24]}>{renderItem}</Grid>}
          next={() => {}}
          hasMore={hasMoreData}
          dataLength={items.length}
          isLoading={isLoading}
          endMessage={
            <Row
              align="middle"
              justify="end"
              className={Styles['instagram-btn-row']}
            >
              <Col>
                <Button
                  onClick={() => {
                    window.open(
                      'https://www.instagram.com/kick.avenue',
                      '_blank',
                    );
                  }}
                  style={{ padding: '0 64px' }}
                >
                  Visit our Instagram <b>@kick.avenue</b>
                </Button>
              </Col>
            </Row>
          }
        />
      </Section>
    </div>
  );
};

export default WhatsGoingOnSection;
